import type { ReactNode } from 'react';

import { colors } from '#/theme/theme';

type Props = {
  children: ReactNode;
};

export function Container({ children }: Props) {
  return (
    <div
      data-qa-id="job-selector"
      style={{
        overflow: 'hidden',
        paddingInline: '4px',
        paddingBlock: '1px',
        background: colors.backgroundGrey,
        borderRadius: '4px',
      }}
    >
      {children}
    </div>
  );
}
